import { Chip, Typography } from "@mui/material";
import { t } from "i18next";
import EditIcon from "@mui/icons-material/Edit";
import {
  BasicTableRowStyles,
  TableHeaderWrapper,
  TableWrapper,
} from "../../../components/common/Common.styles";
import CellBox from "../../../components/common/table/CellBox";
import BorderRow from "../../../components/common/table/BorderRow";
import DeleteBtn from "../../../components/common/table/DeleteBtn";
import ServerSideTableColumnHeader from "../../../components/common/table/ServerSideTableColumnHeader";
import { GeneralButton } from "../../../common/ui/GeneralButton";
import { WalletType } from "../../../types/walletType";

interface Props {
  walletTypes: WalletType[];
  handleEditWalletType: (walletType: WalletType) => void;
  handleDeleteWalletType: (walletType: WalletType) => void;
}

export default function WalletTypesTable(props: Props) {
  return (
    <TableWrapper columnsTemplate="2fr 3fr 1fr auto">
      <TableHeaderWrapper>
        <ServerSideTableColumnHeader
          isSorted={false}
          label={t("walletTypes.columns.name")}
          firstCol
        />
        <ServerSideTableColumnHeader
          isSorted={false}
          label={t("walletTypes.columns.description")}
        />
        <ServerSideTableColumnHeader
          isSorted={false}
          label={t("walletTypes.columns.fallback")}
        />
        <BorderRow />
      </TableHeaderWrapper>

      {props.walletTypes.map((item) => (
        <BasicTableRowStyles key={item.id}>
          <CellBox firstCol contentPosition="flex-start">
            <Typography>{item.name}</Typography>
          </CellBox>
          <CellBox contentPosition="flex-start">
            <Typography>{item.description}</Typography>
          </CellBox>
          <CellBox contentPosition="flex-start">
            {item.isFallback && (
              <Chip
                label={t("walletTypes.fallbackBadge")}
                color="primary"
                size="small"
              />
            )}
          </CellBox>
          <CellBox lastCol>
            <GeneralButton
              appVariant="icon"
              onClick={() => props.handleEditWalletType(item)}
            >
              <EditIcon />
            </GeneralButton>
            <DeleteBtn
              isCreateNewMode={false}
              isDisabled={item.isFallback}
              hoverText={
                item.isFallback
                  ? t("walletTypes.cannotDeleteFallbackTooltip")
                  : undefined
              }
              dialogMessage={t("walletTypes.confirmDelete")}
              handleOnDelete={() => props.handleDeleteWalletType(item)}
            />
          </CellBox>
          <BorderRow />
        </BasicTableRowStyles>
      ))}
    </TableWrapper>
  );
}
